(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["seedshub-v2"] && !Shopify.designMode) return;
  try {
    
const initSeedshubAnchorNav = (root = document) => {
  root.querySelectorAll('[data-sv2-anchor-nav]').forEach((nav) => {
    if (nav.dataset.sv2AnchorReady === 'true') return;
    document.body.classList.add('sv2-home-active');
    const syncHeaderOffset = () => {
      const header = document.querySelector('#x-header-container');
      const headerSection = header?.closest('.section-header');
      if (!header || !headerSection || getComputedStyle(headerSection).position !== 'sticky') {
        nav.style.removeProperty('--sv2-anchor-top');
        return;
      }
      const headerRect = header.getBoundingClientRect();
      const visibleBottom = headerRect.bottom > 0 && headerRect.top < window.innerHeight ? Math.max(0, headerRect.bottom) : 0;
      nav.style.setProperty('--sv2-anchor-top', `${Math.round(visibleBottom)}px`);
    };
    window.addEventListener('scroll', syncHeaderOffset, { passive: true });
    window.addEventListener('resize', syncHeaderOffset);
    nav.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (event) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        syncHeaderOffset();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const stickyTop = Number.parseFloat(getComputedStyle(nav).top) || 0;
        const top = target.getBoundingClientRect().top + window.scrollY - nav.offsetHeight - stickyTop - 12;
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
        window.history.replaceState(null, '', link.getAttribute('href'));
      });
    });
    nav.dataset.sv2AnchorReady = 'true';
    syncHeaderOffset();
  });
};
const initSeedshubComparisons = (root = document) => {
  root.querySelectorAll('[data-sv2-comparison]').forEach((comparison) => {
    if (comparison.dataset.sv2Ready === 'true') return;
    const range = comparison.querySelector('.sv2-comparison-range');
    if (!range) return;
    const update = () => comparison.style.setProperty('--sv2-position', `${range.value}%`);
    range.addEventListener('input', update);
    comparison.dataset.sv2Ready = 'true';
    update();
  });
};
const resetSeedshubVideoCard = (card) => {
  const nativeVideo = card.querySelector('video');
  if (nativeVideo) {
    if (!nativeVideo.paused) nativeVideo.pause();
    nativeVideo.muted = true;
    nativeVideo.controls = false;
    nativeVideo.currentTime = 0;
  }
  card.classList.remove('is-playing');
};
const pauseOtherSeedshubVideos = (activeCard) => {
  document.querySelectorAll('[data-sv2-video-card]').forEach((otherCard) => {
    if (otherCard === activeCard) return;
    resetSeedshubVideoCard(otherCard);
  });
};
const initSeedshubVideos = (root = document) => {
  root.querySelectorAll('[data-sv2-video-card]').forEach((card) => {
    if (card.dataset.sv2VideoReady === 'true') return;
    const button = card.querySelector('[data-sv2-play]');
    const video = card.querySelector('video');
    if (!button || !video) return;
    const showPlayingState = () => card.classList.add('is-playing');
    button.addEventListener('click', () => {
      pauseOtherSeedshubVideos(card);
      video.controls = true;
      video.muted = false;
      const playRequest = video.play();
      if (playRequest && typeof playRequest.catch === 'function') {
        playRequest.catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    });
    if (video) {
      video.addEventListener('play', () => {
        pauseOtherSeedshubVideos(card);
        showPlayingState();
      });
      video.addEventListener('ended', () => resetSeedshubVideoCard(card));
    }
    card.dataset.sv2VideoReady = 'true';
  });
};
const initSeedshubSubscribe = (root = document) => {
  root.querySelectorAll('[data-sv2-subscribe]').forEach((popup) => {
    if (popup.dataset.sv2SubscribeReady === 'true') return;
    const closeButton = popup.querySelector('[data-sv2-subscribe-close]');
    const storageKey = 'seedshub-v2-subscribe-shown-at';
    const delay = Number(popup.dataset.delay || 15000);
    const frequencyDays = Number(popup.dataset.frequencyDays || 7);
    const frequencyWindow = frequencyDays * 24 * 60 * 60 * 1000;
    const hasSuccess = Boolean(popup.querySelector('.sv2-subscribe-success'));
    const copyButton = popup.querySelector('[data-sv2-copy-code]');
    let shown = false;
    let timer;
    const readLastShown = () => {
      try {
        return Number(window.localStorage.getItem(storageKey) || 0);
      } catch (error) {
        return 0;
      }
    };
    const rememberShown = () => {
      try {
        window.localStorage.setItem(storageKey, String(Date.now()));
      } catch (error) {
        return;
      }
    };
    const stopTriggers = () => {
      window.clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    };
    const show = () => {
      if (shown) return;
      shown = true;
      popup.classList.add('is-visible');
      window.dispatchEvent(new CustomEvent('sv2:subscribe-change'));
      rememberShown();
      stopTriggers();
    };
    const onScroll = () => {
      const threshold = Math.min(520, document.documentElement.scrollHeight * 0.22);
      if (window.scrollY >= threshold) show();
    };
    closeButton?.addEventListener('click', () => {
      popup.classList.remove('is-visible');
      window.dispatchEvent(new CustomEvent('sv2:subscribe-change'));
      stopTriggers();
    });
    copyButton?.addEventListener('click', async () => {
      const code = copyButton.dataset.code || '';
      try {
        await navigator.clipboard.writeText(code);
        copyButton.textContent = copyButton.dataset.copiedLabel || copyButton.textContent;
      } catch (error) {
        return;
      }
    });
    popup.dataset.sv2SubscribeReady = 'true';
    if (hasSuccess || (window.Shopify && window.Shopify.designMode)) {
      show();
      return;
    }
    if (Date.now() - readLastShown() < frequencyWindow) return;
    timer = window.setTimeout(show, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  });
};
const initSeedshubBackTop = (root = document) => {
  root.querySelectorAll('[data-sv2-back-top]').forEach((button) => {
    if (button.dataset.sv2BackTopReady === 'true') return;
    const popup = document.querySelector('[data-sv2-subscribe]');
    const syncPopupOffset = () => {
      const visiblePopup = document.querySelector('.sv2-subscribe.is-visible');
      if (!visiblePopup) {
        button.style.removeProperty('--sv2-back-top-bottom');
        return;
      }
      const popupRect = visiblePopup.getBoundingClientRect();
      const gap = window.innerWidth <= 799 ? 10 : 12;
      button.style.setProperty('--sv2-back-top-bottom', `${Math.round(window.innerHeight - popupRect.top + gap)}px`);
    };
    const updateVisibility = () => {
      const threshold = Math.max(520, window.innerHeight * 0.72);
      button.classList.toggle('is-visible', window.scrollY > threshold);
      syncPopupOffset();
    };
    button.addEventListener('click', () => {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    });
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', syncPopupOffset);
    window.addEventListener('sv2:subscribe-change', () => window.requestAnimationFrame(syncPopupOffset));
    if (popup && 'ResizeObserver' in window) {
      const popupObserver = new ResizeObserver(syncPopupOffset);
      popupObserver.observe(popup);
    }
    button.dataset.sv2BackTopReady = 'true';
    updateVisibility();
  });
};
initSeedshubAnchorNav();
initSeedshubComparisons();
initSeedshubVideos();
initSeedshubSubscribe();
initSeedshubBackTop();
document.addEventListener('shopify:section:load', (event) => {
  initSeedshubAnchorNav(event.target);
  initSeedshubComparisons(event.target);
  initSeedshubVideos(event.target);
  initSeedshubSubscribe(event.target);
  initSeedshubBackTop(event.target);
});

  } catch(e) { console.error(e); }
})();
})();
